module.exports = require("./az.d.ts");